import {
  ColumnFormat,
  ComponentType,
  type IColumn,
  type IFormilySchema,
} from '../types';
import { isArrayTableComponent } from './findFormComponent';
import { getSchemaFieldsV2 } from './getSchemaFields';
import { normalizeDataIndex } from './normalizeDataIndex';

export const extractColumnsFromSchema = (
  childSchema?: IFormilySchema
): IColumn[] => {
  return getSchemaFieldsV2<IColumn>(
    childSchema,
    fieldDef => !isArrayTableComponent(fieldDef),
    (key, fieldDef) => {
      const dataIndex = (fieldDef.name || key).split('.');
      const isReferenceSelect =
        fieldDef['x-component'] === ComponentType.FormReferenceSelect;
      return {
        id: normalizeDataIndex(dataIndex),
        title: fieldDef.title || key,
        dataIndex,
        format: isReferenceSelect
          ? ColumnFormat.REFERENCE
          : ColumnFormat.STRING,
        defaultVisible: true,
        tranformer: isReferenceSelect
          ? fieldDef['x-component-props']?.transformer
          : undefined,
      };
    }
  );
};
